import { FC, SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

const DownIcon: FC<IconProps> = props => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='10'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <path
        d='M2.66602 5.33203L7.99935 10.6654L13.3327 5.33203'
        stroke='#9E9E9E'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

DownIcon.displayName = 'DownIcon';
export default DownIcon;
